import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ToolsService } from "../../services/tools.service";
import { WindowBarComponent } from "./bar/window-bar.component";
import { WindowHostComponent } from "./host/window-host.component";
import { WindowContentWrapperComponent } from "./window-content-wrapper.component";

@NgModule({
  declarations: [WindowHostComponent, WindowBarComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatTooltipModule,
    MatSidenavModule,
    DragDropModule,
    WindowContentWrapperComponent,
  ],
  exports: [
    WindowHostComponent,
    WindowBarComponent,
    WindowContentWrapperComponent,
  ],
  providers: [ToolsService],
})
export class WindowManagerModule {}
